module.exports = __webpack_public_path__ + "fonts/comshiva.b9c5603a.eot";